import { Scene, PerspectiveCamera, WebGLRenderer, Clock } from 'three';

import Sky from './sky';
import Slider from './slider';
import Mouse from './mouse';
import Parallax from './parallax';
import Tab from './tab';
import { debounce } from '../utils';

export default class SceneManager {
  constructor(state, container) {
    this.state = state;
    this.container = container;

    this.scene = new Scene();

    this.pixelRatio = window.devicePixelRatio;

    this.camera = new PerspectiveCamera(75, (window.innerWidth) / window.innerHeight, 0.5, 1500);
    this.camera.position.set(0, 0, 0);

    this.initRender();
    this.initObjects();

    this.resize = this.resize.bind(this);
    window.addEventListener('DOMContentLoaded', this.resize);

    const debouncedResize = debounce(this.resize, 0);
    window.addEventListener('resize', debouncedResize);
    this.start_time = Date.now();
  }


  initRender() {
    this.renderer = new WebGLRenderer({
      powerPreference: 'low-power',
      antialias: false,
    });

    this.renderer.setPixelRatio(this.pixelRatio);
    this.renderer.setSize(window.innerWidth, window.innerHeight);
    this.renderer.autoClear = false;
  }

  initObjects() {
    this.clock = new Clock();
    this.sky = new Sky(this.scene, this.camera);
    this.slider = new Slider(this.state, this.scene, this.camera, this.container);
    this.mouseControls = new Mouse(this.state, this.scene, this.camera, this.container, this.slider);
    this.tab = new Tab(this.slider);
    this.parallax = new Parallax(this.camera, this.slider.beacons, this.tab, this.container);

    this.slider.initEventListeners(this.tab);
  }

  resize() {
    // TODO: pull 768 from config or share with css breakpoint
    // TODO: adjust the beacons z position within the container to simplify these numbers?
    if ('ontouchstart' in document.documentElement) {
      this.slider.obj.position.z = -1 * (768 / this.container.clientWidth);
    }
    this.camera.aspect = this.container.clientWidth / this.container.clientHeight;
    this.camera.updateProjectionMatrix();

    this.renderer.setSize(this.container.clientWidth, this.container.clientHeight);
  }

  update() {
    this.sky.update();
    this.renderer.render(this.scene, this.camera);
  }
}
